import React, { useEffect } from 'react';
import { FormTextInput } from 'protocol-setup/components/FormComponents';
import { useOEWGDate } from 'protocol-setup/redux/useLovs';


const OEWGDateInput = ({ protocolNumber, requestStatus, control, setValue }) => {

  const { oewgDate, isLoadingOEWGDate } = useOEWGDate(protocolNumber, requestStatus);
  useEffect(() => {
    if (oewgDate) {
      setValue('oewgDate', oewgDate);
    }
  }, [oewgDate, setValue]);

  if (isLoadingOEWGDate) {
    return <div>Loading...</div>;
  }
  return (
    <FormTextInput
      name="oewgDate"
      section="openRave"
      form="infoForm"
      control={control}
      type="text"
      readOnly
      value={oewgDate}
    />
  );
};

export default OEWGDateInput;